import styled from "styled-components"

export const Title = styled.h2<{ $marginBottom?: boolean }>`
  margin: ${({ $marginBottom }) => ($marginBottom ? "0 0 1.6rem" : "0")};
  font-size: 3rem;
  line-height: 4.3rem;
  letter-spacing: 0.04em;
  font-weight: 300;
`
